export default __webpack_public_path__ + "static/media/KAVIAR_4.098dd5fc.gif";